import { ButtonProps } from '@msc-b2c/interfaces/types';
import { Icon } from '../icons/Icon';
import clsx from 'clsx';

import './button.module.scss';
import {
  handleKeyDown,
  handleSubmitButtonBlur,
  handleSubmitButtonKeyDown,
  handleSubmitButtonKeyUp,
  keyCodes,
} from '@msc-b2c/shared-utils/keyboardUtils';

export const Button = ({
  id,
  buttonType = 'button',
  text,
  icon,
  iconAriaLabel = '',
  disabled,
  accessibilityLabel,
  styleOption = '',
  buttonLink,
  buttonTarget,
  tooltipText,
  ariaHidden,
  onClick,
}: ButtonProps) => {
  return text || icon ? (
    <div
      id={id}
      className={clsx(styleOption, { '-icon-only': icon && !text })}
    >
      {buttonLink?.url ? (
        <a
          className={clsx('cmp-button', { disabled: disabled })}
          href={disabled ? undefined : buttonLink?.url}
          onClick={onClick}
          onKeyDown={
            disabled || ariaHidden
              ? undefined
              : (event) => {
                  if (event.key === keyCodes.SPACE) {
                    event.preventDefault();
                    (event.currentTarget as HTMLAnchorElement).click();
                  }
                }
          }
          aria-label={accessibilityLabel}
          aria-disabled={disabled}
          tabIndex={disabled || ariaHidden ? -1 : 0}
          target={buttonTarget ?? '_self'}
          aria-hidden={ariaHidden ?? false}
        >
          {icon && (
            <Icon
              icon={icon}
              ariaHidden={!!accessibilityLabel || !!text}
              tooltipTitle={accessibilityLabel}
            />
          )}
          <span>{text}</span>
        </a>
      ) : (
        <button
          type={buttonType}
          className={'cmp-button'}
          aria-label={accessibilityLabel}
          disabled={disabled}
          onClick={onClick}
          onKeyDown={
            disabled
              ? undefined
              : buttonType === 'submit'
              ? handleSubmitButtonKeyDown
              : onClick
              ? (event) => handleKeyDown(event, onClick)
              : undefined
          }
          onKeyUp={disabled || buttonType !== 'submit' ? undefined : handleSubmitButtonKeyUp}
          onBlur={disabled || buttonType !== 'submit' ? undefined : handleSubmitButtonBlur}
          aria-disabled={disabled}
          tabIndex={disabled || ariaHidden ? -1 : 0}
          aria-hidden={ariaHidden ?? false}
        >
          {icon && (
            <Icon
              icon={icon}
              ariaLabel={accessibilityLabel || text ? undefined : iconAriaLabel}
              ariaHidden={!!accessibilityLabel || !!text}
              tooltipTitle={tooltipText}
            />
          )}
          {text && <span>{text}</span>}
        </button>
      )}
    </div>
  ) : null;
};
